import utils from "../scripts/utils";

const androidCaller = {
  callFunction: function (name, data) {
    try {
      if (data) {
        data = utils.fromJsonToString(data);
        Cielo[name](data);
      } else {
        Cielo[name]();
      }
    } catch (e) {
      console.log("Error trying to access " + name + " method. " + e);
    }
  },
};

const iosCaller = {
  callFunction: function (name, data) {
    try {
      window.webkit.messageHandlers[name].postMessage(data || "");
    } catch (e) {
      console.log("Error trying to access " + name + " method. " + e);
    }
  },
};

export { androidCaller, iosCaller };
